module.exports = __webpack_public_path__ + "img/totalmeetings50.a8925f1b.png";